import React from 'react';
import {
Nav,
NavLink,
Bars,
NavMenu,
NavBtn,
NavBtnLink,
} from './NavbarElements';
import logo from 'D:/NFT_development/front_end/navigation-bar/src/components/Navbar/logo.png'

const Navbar = () => {
return (
	<>
	<Nav>
		<Bars />
		<NavLink to='/' activeStyle>
		<img src={logo} alt="Image" height={50} width={95} style={{alignItems: 'Left'}} />
	    </NavLink>
		<NavMenu>
	
		<NavLink to='/MyWallet' activeStyle>
			Upgrade
		</NavLink>
		<NavLink to='/minter' activeStyle>
			Minter
		</NavLink>
		<NavLink to='/rewards' activeStyle>
			Rewards
		</NavLink>
		<NavLink to='/WizarDAO' activeStyle>
			WizarDAO
		</NavLink>

		{/* Second Nav */}
		{/* <NavBtnLink to='/sign-in'>Sign In</NavBtnLink> */}

		</NavMenu>
		<NavBtn>
		<NavBtnLink to={{ pathname: "https://pixanft.com" }} target="_parent" >Exit App</NavBtnLink>
		</NavBtn>
	</Nav>
	</>
);
};

export default Navbar;
